import { render, staticRenderFns } from "./auditList.vue?vue&type=template&id=38a45522&scoped=true&"
import script from "./auditList.vue?vue&type=script&lang=js&"
export * from "./auditList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a45522",
  null
  
)

export default component.exports